import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export function WhatIsIncluded() {
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const includes = ['Cómo funciona realmente el sistema hormonal femenino', 'Qué hábitos afectan tus hormonas sin que lo notes', 'Los alimentos que ayudan a equilibrar el sistema hormonal', 'Errores comunes que empeoran los desequilibrios hormonales', 'Estrategias simples para recuperar energía y bienestar'];
  return <section className="py-16 px-4 bg-white" data-id="element-199">
      <div className="max-w-3xl mx-auto" data-id="element-200">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10" data-id="element-201">
          Dentro de esta guía vas a descubrir:
        </h2>

        <div className="space-y-4 mb-12" data-id="element-202">
          {includes.map((item, index) => <div key={index} className="flex items-start gap-4 p-4 rounded-xl hover:bg-brand-cream transition-colors" data-id="element-203">
              <CheckCircle2Icon className="w-6 h-6 text-brand-green flex-shrink-0 mt-0.5" data-id="element-204" />
              <span className="text-lg text-gray-800" data-id="element-205">{item}</span>
            </div>)}
        </div>

        <p className="text-xl text-center font-playfair italic text-brand-green mb-10" data-id="element-206">
          "Pequeños cambios pueden generar una gran diferencia cuando entendés
          cómo funciona realmente tu cuerpo."
        </p>

        <div className="text-center" data-id="element-207">
          <button onClick={scrollToOffer} className="w-full md:w-auto bg-brand-gold hover:bg-yellow-500 text-brand-green font-bold text-lg md:text-xl py-4 px-8 rounded-xl shadow-[0_8px_20px_rgba(212,168,67,0.4)] hover:shadow-[0_12px_25px_rgba(212,168,67,0.6)] transform hover:-translate-y-1 transition-all duration-300" data-id="element-208">
            SÍ, QUIERO EQUILIBRAR MIS HORMONAS
          </button>
        </div>
      </div>
    </section>;
}